import * as Yup from 'yup';

const PlanSchema = Yup.object({
    name : Yup.string().required(),
    price : Yup.number().required(),
    description : Yup.string().required(),
})

export default PlanSchema;